import {
  PageTypeEnum,
  ProductInfoProduct,
  SearchCriteria,
  UpsellProduct,
} from '../types'

export type ModuleContext = {
  key: number
  pageType: PageTypeEnum
  searchCriteria?: SearchCriteria
  onTrackingInfo?: (event: { product: ProductInfoProduct }) => {
    label: string
    listName: string
    itemIndex: number
  }
}

export type ModuleTwoColumn = {
  __typename: 'ModuleTwoColumn'
  left: Module[]
  right: Module[]
  ratio?: '60/40' | '50/50' | '40/60'
  styles?: {
    alignSelfLeft?: string
    alignSelfRight?: string
    height?: string
    heightLeft?: string
    heightRight?: string
    justifyContentLeft?: string
    justifyContentRight?: string
    matchRightHeightToLeft?: boolean
    minHeight?: string
    minHeightLeft?: string
    minHeightRight?: string
    widthLeft?: string
    widthRight?: string
  }
}

export type ModuleSimplifiedTwoColumnProductHeading = {
  __typename: 'ModuleSimplifiedTwoColumnProductHeading'
  left: Module[]
  right: Module[]
}

export type ModuleSimplifiedModalTwoColumnProductHeading = {
  __typename: 'ModuleSimplifiedModalTwoColumnProductHeading'
  left: Module[]
  right: Module[]
}

export type Tab = {
  title: string
  label: string
  modules: Module[]
}

export type ModuleMultiBuyTabs = {
  __typename: 'ModuleMultiBuyTabs'
  tabs: Tab[]
  meta: { intent: string }
}

export type ModuleSimplifiedMultiBuyTabs = {
  __typename: 'ModuleSimplifiedMultiBuyTabs'
  tabs: Tab[]
  meta: { intent: string }
}

export type ModuleSimplifiedTabs = {
  __typename: 'ModuleSimplifiedTabs'
  tabs: Tab[]
  meta?: { intent: string }
}

export type ModuleSimplifiedProductImage = {
  __typename: 'ModuleSimplifiedProductImage'
}

export type ModuleSimplifiedProductHeading = {
  __typename: 'ModuleSimplifiedProductHeading'
}

export type ModuleSimplifiedDispatch = {
  __typename: 'ModuleSimplifiedDispatch'
}

export type ModuleSimplifiedMultiBuyQuantity = {
  __typename: 'ModuleSimplifiedMultiBuyQuantity'
}

export type ModuleTabs = {
  __typename: 'ModuleTabs'
  tabs: Tab[]
  meta?: { intent: string }
}

export type GroupCardTab = Tab & {
  type: 'SINGLE' | 'GROUP'
}

export type ModuleGroupCardTabs = {
  __typename: 'ModuleGroupCardTabs'
  tabs: GroupCardTab[]
  meta: { intent: string }
}

export type ModuleSingleCard = {
  __typename: 'ModuleSingleCard'
}

export type ModuleTitle = {
  __typename: 'ModuleTitle'
}

export type ModuleHeading = {
  __typename: 'ModuleHeading'
}

export type ModuleSimplifiedHeading = {
  __typename: 'ModuleSimplifiedHeading'
}

export type ModuleSimplifiedVariants = {
  __typename: 'ModuleSimplifiedVariants'
} & Omit<ModuleVariants, '__typename'>

export type ModuleSimplifiedDeliveryInfoText = {
  __typename: 'ModuleSimplifiedDeliveryInfoText'
  unavailableVariants?: string[]
}

export enum ModuleVariantsType {
  RADIO = 'radio',
  DROPDOWN = 'dropdown',
  GRID = 'grid',
}

export type ModuleVariants = {
  __typename: 'ModuleVariants'
  type: ModuleVariantsType
  unavailableVariants?: string[]
  displayOptions?: {
    dropdownTitlePosition?: 'vertical' | 'horizontal'
    titleTypography?: string
    titleColor?: string
    color?: string
    showPriceSuffix?: boolean
    eCardPlacement?: 'first' | 'last'
  }
}

export type ModuleDispatch = {
  __typename: 'ModuleDispatch'
}

export type ModuleButtons = {
  __typename: 'ModuleButtons'
  productType?: 'groupCard'
  header?: Module[]
}

export type ModuleMoreInfo = {
  __typename: 'ModuleMoreInfo'
}

export type ModuleGroupCards = {
  __typename: 'ModuleGroupCards'
}

export type ModuleQuantity = {
  __typename: 'ModuleQuantity'
}

export type ModulePromotions = {
  __typename: 'ModulePromotions'
}

export type ModuleImages = {
  __typename: 'ModuleImages'
}

export type ModuleLink = {
  __typename: 'ModuleLink'
  href: string
  title: string
  meta: {
    intent: string
  }
  alignment?: 'center' | 'flex-start' | 'flex-end'
}

export type ModulePrice = {
  __typename: 'ModulePrice'
  displayOptions?: {
    showSimplifiedExperimentVariant: boolean
    color?: string
  }
}

export type ModuleRating = {
  __typename: 'ModuleRating'
}

export type ModulePeopleAlsoViewed = {
  __typename: 'ModulePeopleAlsoViewed'
}

export type ModulePeopleAlsoViewedVariant = {
  __typename: 'ModulePeopleAlsoViewedVariant'
}

export type ModulePills = {
  __typename: 'ModulePills'
  show?: 'primary only' | 'all'
}

export type ModuleThingsToKnow = {
  __typename: 'ModuleThingsToKnow'
}

export type ModuleList = {
  __typename: 'ModuleList'
  title: string
  items: string[]
}

export type ModuleAddons = {
  __typename: 'ModuleAddons'
}

export type ModuleUpsell = {
  __typename: 'ModuleUpsell'
}

export type ModuleMemberPricingHeader = {
  __typename: 'ModuleMemberPricingHeader'
}

export type ModuleOutOfStock = {
  __typename: 'ModuleOutOfStock'
}

export type ModuleFromPrice = {
  __typename: 'ModuleFromPrice'
  displayOptions?: {
    align: 'right'
    alignXs?: 'left' | 'right'
    color?: string
    inline?: boolean
    showMultiCardDiscountedPrice?: boolean
    showSelectedVariantPrice?: boolean
    showFrom?: boolean
  }
}

type ModuleKlarnaInfo = {
  __typename: 'ModuleKlarnaInfo'
}

export type ModuleVariantTabs = {
  __typename: 'ModuleVariantTabs'
  modules: Module[]
}

type ModuleVariantList = {
  __typename: 'ModuleVariantList'
}

type ModuleProductDetails = {
  __typename: 'ModuleProductDetails'
}

export type ModuleMoreLikeThis = {
  __typename: 'ModuleMoreLikeThis'
}

export type ModuleProductTabs = {
  __typename: 'ModuleProductTabs'
}

export type ModuleUSPList = {
  __typename: 'ModuleUSPList'
}

export type ModulePostcardUpsell = {
  __typename: 'ModulePostcardUpsell'
}

export type ModuleSelectCard = {
  __typename: 'ModuleSelectCard'
}

export type ModuleSellingPoints = {
  __typename: 'ModuleSellingPoints'
}

export type Module =
  | ModuleMultiBuyTabs
  | ModuleSimplifiedMultiBuyTabs
  | ModuleGroupCardTabs
  | ModuleSingleCard
  | ModuleTwoColumn
  | ModuleTitle
  | ModuleVariants
  | ModuleDispatch
  | ModuleButtons
  | ModuleMoreInfo
  | ModuleGroupCards
  | ModuleQuantity
  | ModulePromotions
  | ModuleImages
  | ModuleLink
  | ModulePrice
  | ModulePeopleAlsoViewed
  | ModulePeopleAlsoViewedVariant
  | ModulePills
  | ModuleRating
  | ModuleThingsToKnow
  | ModuleList
  | ModuleAddons
  | ModuleTabs
  | ModuleUpsell
  | ModuleMemberPricingHeader
  | ModuleOutOfStock
  | ModuleFromPrice
  | ModuleVariantTabs
  | ModuleKlarnaInfo
  | ModuleVariantList
  | ModuleHeading
  | ModuleSimplifiedTwoColumnProductHeading
  | ModuleProductDetails
  | ModuleMoreLikeThis
  | ModuleProductTabs
  | ModuleUSPList
  | ModulePostcardUpsell
  | ModuleSelectCard
  | ModuleSellingPoints
  | ModuleSimplifiedModalTwoColumnProductHeading
  | ModuleSimplifiedTabs
  | ModuleSimplifiedProductImage
  | ModuleSimplifiedProductHeading
  | ModuleSimplifiedDispatch
  | ModuleSimplifiedMultiBuyQuantity
  | ModuleSimplifiedHeading
  | ModuleSimplifiedVariants
  | ModuleSimplifiedDeliveryInfoText

export type OnConfigureModulesCallback = ({
  product,
  upsellProduct,
}: {
  product: ProductInfoProduct
  upsellProduct?: UpsellProduct
}) => Module[]
